import { useEffect } from 'react';

interface CallbackActionProps {
  url: string;
}

function CallbackAction({ url }: CallbackActionProps) {
  useEffect(() => {
    if (url) {
      try {
        const isSameDomain =
          new URL(url).origin === new URL(window.location.href).origin;
        if (isSameDomain) {
          window.location.replace(url);
          window.location.reload();
        } else {
          window.location.replace(url);
        }
      } catch {
        window.location.replace(url);
      }
    }
  }, [url]);

  return null;
}

export default CallbackAction;
